import { combineReducers } from 'redux';
import byId from './byId';
import allIds from './allIds';


const employees = combineReducers({
  byId,
  allIds,
});

export default employees;
